import { ReviewSearchFeatureType, ReviewSearchSortType } from 'common/types/entities/api/review'
import { ReviewsFilterState } from 'common/types/entities/review'
import { StateKey } from 'common/utils/flipState'

const initialState: ReviewsFilterState = {
  selectedSort: ReviewSearchSortType.REVIEW_RANKING,
  selectedFeature: ReviewSearchFeatureType.ALL,
  selectedTopic: null,
  changedFilterByUser: false,
}

const SET_SORT = 'review/reviewsFilter/SET_SORT'
const SET_FEATURE = 'review/reviewsFilter/SET_FEATURE'
const SET_TOPIC = 'review/reviewsFilter/SET_TOPIC'
const INIT = 'review/reviewsFilter/INIT'

export const setReviewSearchSort = (curState: StateKey, sortType) => {
  return {
    curState,
    selectedSort: sortType,
    type: SET_SORT,
  }
}

export const setReviewSearchFeature = (curState: StateKey, featureType) => {
  return {
    curState,
    selectedFeature: featureType,
    type: SET_FEATURE,
  }
}

export const setReviewSearchTopic = (curState: StateKey, topicCode) => {
  return {
    curState,
    selectedTopic: topicCode,
    type: SET_TOPIC,
  }
}

export const initReviewFilter = (curState: StateKey) => {
  return {
    curState,
    type: INIT,
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT:
      return initialState
    case SET_SORT:
      return {
        ...state,
        selectedSort: action.selectedSort,
        changedFilterByUser: true,
      }
    case SET_FEATURE:
      return {
        ...state,
        selectedFeature: action.selectedFeature,
        changedFilterByUser: true,
      }
    case SET_TOPIC:
      return {
        ...state,
        selectedTopic: action.selectedTopic,
        changedFilterByUser: true,
      }
    default:
      return state
  }
}

export default reducer
